import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.name !== 'dev' && environment.name !== 'local') {
  Sentry.init({
    dsn: 'https://ce87c15c0640f750d86e23aabfcf4425@o557238.ingest.us.sentry.io/4509842840420353',
    sendDefaultPii: true,
    environment: environment.name,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
      }),
      Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
    ],
    replaysSessionSampleRate: 0.005, // 0.5% of all sessions
    replaysOnErrorSampleRate: 0.05, // 5% of error sessions
    enableLogs: true,
    tracePropagationTargets: [/^.*hub.airgateway.*$/],
  });
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
